import React, { Component } from 'react'
import $ from 'jquery';

class Dropdownmenu extends Component{      

    componentDidMount = () => {        
        $( document ).ready(function() {
            // Handler for .ready() called.                        
            const dropdown = $( ".nav-header .dropdown-container" );                           
            $('a.activate-dropdown').on('click', function(event){
                event.preventDefault();
                // console.log('Store Dropdown Link Clicked!');                                                
                if ($(this).hasClass("active")){                    
                    $(this).removeClass("active");
                    $(dropdown).removeClass("active"); 
                    $( ".nav-header .dropdown-container ul" ).removeClass("active");
                    $(".dropdown-overlay").remove();
                    dropdown.empty(); 
                } else{                    
                    // console.log('Store Dropdown Open');
                    const n = document.createElement("div");
                    $(n).addClass("dropdown-overlay");
                    $(n).on("click", function() {
                        document.body.removeChild(n);
                        $(".activate-dropdown").removeClass("active");
                        dropdown.removeClass("active");
                        dropdown.empty();
                    });

                    document.body.appendChild(n);
                    $(this).addClass("active");                                       
                    dropdown.addClass("active");                    
                    $(".dropdown-content").clone().appendTo(dropdown);
                    $( ".nav-header .dropdown-container ul" ).addClass("active");                   
                }                                                                              
            });            
        });                
        
    }

    render(){        
        return(                 
            <React.Fragment>
            </React.Fragment>
         );
    }            
    
}

export default  Dropdownmenu;